module.exports = __webpack_public_path__ + "static/media/surtidor-verde.b56ec428.svg";